export type AccountInformationRow = {
  id: number;
  createdDate: number;
  affiliate: string;
  bankType: 'Bank' | 'Postal Bank';
  bankName: string;
  branchName: string;
  accountType: 'Ordinary' | 'Saving';
  accountNumber: string;
  accountHolderName: string;
};

export const accountInformationRows: AccountInformationRow[] = [
  ['Sato Haruto', 'Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Ordinary', '01010101', 'Sato Haruto'],
  ['Suzuki Yuna', 'Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Saving', '01010101', 'Suzuki Yuna'],
  ['Takahashi Ren', 'Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Ordinary', '01010101', 'Takahashi Ren'],
  ['Tanaka Aoi', 'Postal Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Ordinary', '01010101', 'Tanaka Aoi'],
  ['Watanabe Sakura', 'Postal Bank', 'Japan Postal Bank', 'Shinjuku Branch', 'Ordinary', '01010101', 'Watanabe Sakura'],
  ['Ito Kaito', 'Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Saving', '01010101', 'Ito Kaito'],
  ['Yamamoto Yuki', 'Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Ordinary', '01010101', 'Yamamoto Yuki'],
  ['Nakamura Sora', 'Bank', 'Sumitomo Mitsui Bank', 'Shinjuku Branch', 'Ordinary', '01010101', 'Nakamura Sora'],
  [
    'Kobayashi Hinata',
    'Postal Bank',
    'Sumitomo Mitsui Bank',
    'Shinjuku Branch',
    'Saving',
    '01010101',
    'Kobayashi Hinata',
  ],
  ['Kato Riku', 'Postal Bank', 'Japan Postal Bank', 'Shinjuku Branch', 'Saving', '01010101', 'Kato Riku'],
].map(([affiliate, bankType, bankName, branchName, accountType, accountNumber, accountHolderName], index) => ({
  id: index + 1,
  createdDate: Date.now() - index * 86_400_000,
  affiliate,
  bankType: bankType as AccountInformationRow['bankType'],
  bankName,
  branchName,
  accountType: accountType as AccountInformationRow['accountType'],
  accountNumber,
  accountHolderName,
}));
